const styles = {
  body: {
    postition: "static",
    display: "block",
    width: "100%",
  },
  topLeft: {
    display: "grid",
    gridAutoColumns: "1fr",
    gridColumnGap: "16px",
    gridRowGap: "0px",
    gridTemplateColumns: "1fr",
    backgroundOosition: "0px 0px",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  logoStyle: {
    width: "75%",
    padding: "15px",
  },

  leftModalTop: {
    backgroundColor: "rgba(29, 41, 63, 0.9)",
    display: "flex",
    padding: "0",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "left",
    width: "100%",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "10px",
  },

  leftModalBottom: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "2.5em",
    backgroundColor: "rgba(3, 78, 161, 0.9)",
    borderBottomLeftRadius: "10px",
    borderBottomRightRadius: "10px",
  },

  explorerCard: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "2.5em",
    backgroundColor: "rgba(3, 78, 161, 0.9)",
    borderRadius: "10px",
  },

  topHead: {},

  headerConferencia: {
    color: "#eb9346",
    fontSize: "24px",
    lineHeight: "22px",
    marginBlockEnd: "0px",
  },

  cardContentConferencia: {
    color: "#fff",
    fontSize: "16px",
    lineHeight: "15px",
    fontWeight: "400",
    textTransform: "none",
    marginBlockStart: "0px",
  },

  loginButton: {
    marginRight: "1em",
    padding: "1.2em 2em",
    flex: "0 0 auto",
    borderRadius: "5px",
    backgroundColor: "#eb9346",
    transition: "all 200ms ease",
    color: "#fff",
    fontSize: "14px",
    lineHeight: "15px",
    fontWeight: "700",
    textAlign: "center",
    letterSpacing: "0.2px",
    textDecoration: "none",
    width: "100%",
    cursor: "pointer",
  },

  loginInfo: {
    padding: "2.5em",
    border: "1px none #000",
  },

  loginTitle: {
    color: "#333745",
    fontSize: "24px",
    lineHeight: "22px",
    marginTop: "0px",
    marginBottom: "0px",
  },

  loginSubtitle: {
    color: "#8c97ac",
    fontSize: "16px",
    lineHeight: "15px",
    fontWeight: "400",
    textTransform: "none",
    marginBlockStart: "0px",
  },

  loginEmail: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "stretch",
    marginTop: "2em",
    marginBottom: "2em",
    margin: "0 0 15px",
  },

  labelTitle: {
    color: "#8c97ac",
    marginBottom: "5px",
    fontWeight: "bold",
  },

  emailGroup: {},

  sharedInput: {
    height: "30px",
    borderRadius: "5px",
    boxSizing: "borderBox",
    width: "100%",
    marginBottom: "10px",
    fontSize: "14px",
    color: "#333333",
    verticalAlign: "middle",
    backgroundColor: "#ffffff",
    border: "1px solid #cccccc",
  },

  passInfo: {
    display: "grid",
  },

  linkFederado: {
    display: "block",
    padding: "0em",
    marginBottom: "5px",
    borderRadius: "5px",
    backgroundColor: "transparent",
    color: "#eb9346",
    fontSize: "13px",
    textAlign: "left",
  },

  passGroup: {},

  socialGroup: {
    display: "flex",
    justifyContent: "center",
  },

  loginError: {
    color: "red",
  },

  socialGroup: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
  },

  socialLoginButton: {
    paddingTop: "10px",
  },
};

export default styles;
